import React, { createContext, useContext, useRef, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Create the context
const ScrollContext = createContext(null);

// Custom hook to use the scroll context
export const useScroll = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScroll must be used within a ScrollProvider');
  }
  return context;
};

// ScrollHandler component for automatic scrolling on route changes
export const ScrollHandler = () => {
  const location = useLocation();
  const { scrollRef } = useScroll();
  
  useLayoutEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, 0);
    }
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    // Reset scroll position for any containers with overflow
    const scrollContainers = document.querySelectorAll('[style*="overflow"]');
    scrollContainers.forEach(container => {
      if (container.scrollTop > 0) {
        container.scrollTop = 0;
      }
    });
  }, [location.pathname, scrollRef]);
  
  return null;
};

// Provider component
export const ScrollProvider = ({ children }) => {
  const scrollRef = useRef(null);
  
  // Create the context value object
  const scrollContextValue = {
    scrollRef
  };
  
  // Provide the context value to children
  return (
    <ScrollContext.Provider value={scrollContextValue}>
      {children}
      <ScrollHandler />
    </ScrollContext.Provider>
  );
}; 